import React, { useState, useEffect } from 'react';
import { CustomGrid, CustomInfosForm } from '../../../../assets/style/globalStyle';
import { Link as RouterLink } from 'react-router-dom';
import { Stack, Typography, Button, Card, Grid } from '@mui/material';
import { formatDate } from '../../../../@core/utils/utilsFunctions';
import { isMobile } from 'react-device-detect';
import { NotificationManager } from 'react-notifications';
import DataGrid, {
  Scrolling,
  Paging,
  HeaderFilter,
  Pager,
  SearchPanel,
  GroupPanel,
  Column,
  ColumnChooser,
  ColumnFixing
} from 'devextreme-react/data-grid';

import configAxios from '../../../../services/configAxios';
import MoreMenu from '../../../components/multiplesComponents/MoreMenu';
import RenderPage from '../../../layouts/RenderPage';
import Iconify from '../../../../@core/theme/Iconify';
import BreadcrumbsNav from '../../../components/multiplesComponents/BreadCrumbs';
import palette from 'src/@core/theme/palette';

const allowedPageSizes = [5, 10, 20, 30];

const clients = (props) => {
  const [infosClients, setInfosClients] = useState({});
  const [infoState] = useState({});
  // const [infosFilter, setInfosFilter] = useState([]);

  useEffect(() => {
    getInfosClients();
  }, []);

  function getInfosClients() {
    configAxios
      .get(`/associates/getAssociates`)
      .then((response) => {
        setInfosClients(response.data);
      })
      .catch(() => {
        NotificationManager.warning(
          'Tivemos dificuldades para buscar os clientes, por favor, tente novamente!',
          'Atenção'
        );
      });
  }

  // function HandleInputsFilters(event) {
  //   setInfosFilter({ ...infosFilter, [event.target.name]: event.target.value });
  // }

  function ActionsButtons(items) {
    const infos = [];
    infos.push(items.data.data);
    return infos.map((item) => (
      <MoreMenu
        key={item.id}
        infos={{
          id: item.id,
          router: 'editClients',
          functionGrid: getInfosClients,
          otherInfos: item,
          statusvenda: item.statusvenda
        }}
      />
    ));
  }

  function FormatDate(data) {
    if (data.data) {
      let dateFormated = formatDate(data.data);
      return dateFormated;
    } else {
      return '-';
    }
  }
  return (
    <RenderPage title="Beneficiários">
      <>
        <Stack direction="row" alignItems="center" justifyContent="start" mb={2}>
          <Grid container>
            <BreadcrumbsNav {...props} />
            <Grid item xs={12} sx={{ mt: 2 }}>
              <Typography variant="h4" gutterBottom>
                Lista de associados
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="subtitle2" gutterBottom>
                Utilize as opções abaixo para visualizar os associados
              </Typography>
            </Grid>
          </Grid>
          <Stack direction="row" alignItems="center" justifyContent="end" mb={2}>
            {infoState.id_type_user === 2 && infoState.id_profile === 3 && (
              <Button
                variant="contained"
                component={RouterLink}
                to="/app/addClients"
                startIcon={<Iconify icon="eva:plus-fill" />}>
                Nova
              </Button>
            )}
            {!isMobile && (
              <Button
                variant="outlined"
                onClick={getInfosClients}
                sx={{ ml: 1 }}
                startIcon={<Iconify icon="eva:refresh-outline" />}>
                Atualizar
              </Button>
            )}
          </Stack>
        </Stack>
        <Card>
          <CustomGrid>
            <CustomInfosForm style={{ color: palette.primary.contrastText }}>
              * Sem filtros, a busca é limitada aos últimos 200 registros
            </CustomInfosForm>
            <Grid container spacing={2} sx={{ mt: 2, mb: 2 }}>
              {/* <Grid style={{ color: palette.primary.PlaceholderColor }} item xs={12} md={3}>
                <TextField
                  style={{ color: palette.primary.PlaceholderColor }}
                  name="dateinitial"
                  fullWidth
                  label="Data inicial"
                  variant="outlined"
                  size="small"
                  type="date"
                  value={infosFilter.dateinitial || ''}
                  onChange={(event) => HandleInputsFilters(event)}
                  InputLabelProps={{
                    shrink: true
                  }}
                />
              </Grid> */}
              {/* <Grid item xs={12} md={3}>
                <TextField
                  name="dateend"
                  fullWidth
                  label="Data final"
                  variant="outlined"
                  size="small"
                  type="date"
                  value={infosFilter.dateend || ''}
                  onChange={(event) => HandleInputsFilters(event)}
                  InputLabelProps={{
                    shrink: true
                  }}
                />
              </Grid> */}
              {/* {!isMobile && (
                <Grid item xs={12} md={2}>
                  <Button
                    variant="contained"
                    size="medium"
                    color="primary"
                    onClick={() => getInfosClients()}
                    startIcon={<Iconify icon="eva:funnel-outline" />}
                    sx={{ mr: 2 }}>
                    Filtrar
                  </Button>
                </Grid>
              )} */}
              {/* {isMobile && (
                <Grid item xs={12} md={2}>
                  <Stack direction="row" alignItems="center" justifyContent="end" sx={{ mb: 1 }}>
                    <Button
                      variant="contained"
                      size="medium"
                      color="primary"
                      onClick={() => getInfosClients()}
                      startIcon={<Iconify icon="eva:funnel-outline" />}
                      sx={{ mr: 2 }}>
                      Filtrar
                    </Button>
                  </Stack>
                </Grid>
              )} */}
            </Grid>
            <DataGrid
              dataSource={infosClients}
              showBorders={true}
              remoteOperations={true}
              wordWrapEnabled={true}
              allowColumnResizing={true}
              columnAutoWidth={true}
              allowExportSelectedData={true}
              noDataText={'Não foram encontrados registros'}>
              <Column dataField="id" />
              <Column dataField="codContrato" caption="Contrato" />
              <Column dataField="nomeUsuario" caption="Nome" />
              <Column dataField="cidade" />
              <Column dataField="bairro" />
              <Column dataField="celular" />
              <Column
                dataField="dtInicio"
                caption="Dt. Início"
                cellRender={(data) => <FormatDate data={data.data.dtInicio} />}
              />
              <Column dataField="status" />
              <Column
                dataField="Ações"
                allowExporting={false}
                allowSorting={false}
                cellRender={(data) => <ActionsButtons data={data} />}
              />
              <SearchPanel visible={true} width={240} placeholder="Procurar..." />
              {!isMobile && (
                <GroupPanel visible={true} emptyPanelText="Arraste as colunas aqui para agrupar" />
              )}
              <Scrolling rowRenderingMode="virtual"></Scrolling>
              <Paging defaultPageSize={5} />
              <Pager
                visible={true}
                allowedPageSizes={allowedPageSizes}
                showPageSizeSelector={true}
                showInfo={true}
                showNavigationButtons={true}
              />
              <ColumnChooser
                enabled={true}
                title={'Escolher uma coluna'}
                emptyPanelText={'Arraste uma coluna aqui para ocultá-la '}
              />
              <ColumnFixing enabled={true} />
              <HeaderFilter visible={true} allowSearch={true} />
            </DataGrid>
          </CustomGrid>
        </Card>
      </>
    </RenderPage>
  );
};

export default clients;
